module.exports = __webpack_public_path__ + "static/media/04-textpage.eb0f4a22.png";